<template>
  <section class="section section--elevated">
    <div class="container">
      <h2 class="section-title">高性能云手机解决方案</h2>
      <p class="section-lead">海曦与熠知联合研发云手机一体化解决方案，高效承载云游戏和云手机业务</p>
      <div class="features-grid">
        <div v-for="f in cloudPhone" :key="f.title" class="feature-card">
          <div class="feature-icon" v-html="f.icon" />
          <h3>{{ f.title }}</h3>
          <p>{{ f.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const cloudPhone = [
  {
    title: '资源智能分时复用',
    desc: '支持资源智能分时复用架构，同时高效承载云游戏和云手机业务，整体部署与运营成本优势突出。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>'
  },
  {
    title: '多元化业务场景',
    desc: '灵活适配政企办公、云端营销、AI挂机、移动测试等多元化业务场景，一套基础设施多场景复用。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>'
  },
  {
    title: '成本优势突出',
    desc: '相比传统云手机方案降低20%以上运营成本，典型客户案例已验证全年可用性达98%。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>'
  }
];
</script>
